import { useChat } from 'ai/react';
import React, { useEffect } from 'react';
import MiniTravelGuide from './MiniTravelGuide';
import { ccFromSlug } from 'tf-post-parser';

export default function LiveTravelGuide(props) {
  const { query } = props;
  let { country, subdivision, city } = query;
  if (!subdivision) subdivision = props.subdivision;
  if (!city) city = props.city;
  const countryCode = query.countryCode || ccFromSlug(country);

  const { messages, append } = useChat({
    api: '/api/travel-guide',
    body: { location: { countryCode, subdivision, city } },
  });

  useEffect(() => {
    append([
      {
        content: `Write a travel guide.`,
        role: 'user',
      },
    ]);
  }, []);

  return (
    <MiniTravelGuide
      {...props}
      body={messages && messages.length > 1 ? messages[1].content : undefined}
    />
  );
}
